define('views/blocks/paymentModeProviders/OgoneIFrameView',['underscore', 'app', 'ApiRequest',
    'PaymentModeSelectionBoardView',
    'template!blocks/paymentmodes/ogone-iframe',
],function(_, app, ApiRequest,
    PaymentModeSelectionBoardView,
    ogoneIFrameTemplate
){
    var detailsDOMWrapper = _.template('<div class="inline-loader ogone-details__wrapper"><%= inner %></div>');

    function onIframeSuccess(event) {
        // listen iframe communication, with ogone_validation
        if (event.data && event.data.type && (event.data.type == 'ogone_validation')) {
            app.trigger('onOgoneIframeSuccess', event.data);
        }
    }
    window.addEventListener('message', onIframeSuccess, true);

    return PaymentModeSelectionBoardView.extend({
        eventsOverride:{
          'change [name=brand]':'changeBrand',
          'change #storepermently':'displayAddCardForm',
        },
        name:'ogone-iframe',
        afterRender:function(){
            var view = this;
            view.displayAddCardForm()
            view.listenTo(app, 'onOgoneIframeSuccess', view.onIframeSuccess);
        },
        renderInner:function(){
            var paymentMode = this.paymentMode;
            return ogoneIFrameTemplate();
        },
        getBrands:function(){
            var paymentMode = this.paymentMode,
                idBrands = paymentMode.getParam('brand'),
                brands = app.getPaymentBrands().byIds(idBrands, paymentMode.id);
            return brands;
        },
        getSelectedBrand:function(e){
            var view = this,
                paymentMode = view.paymentMode,
                cbBrand = paymentMode.getOption('cbBrand',false,true),
                selectedBrand = view.getBrands().findWhere({brand:cbBrand, id_payment_mode: paymentMode.id});
            return selectedBrand;
        },
        displayAddCardForm:function(){
            var view = this,
                checkoutModel = view.checkoutModel,
                details$El = view.$('.ogone__iframe-wrapper'),
                paymentMode = view.paymentMode,
                selectedBrand = view.getSelectedBrand(),
                storepermently = paymentMode.getOption('storepermently',null,true),
                attach_to_cart = true;
            var id_store;
            if(checkoutModel){
                id_store = checkoutModel.getCart().getStore().id;
            }else{
                id_store = 'auto';
                attach_to_cart = false;
            }
            var requestParams = {
                    // todo : j'ai utilisé id_payment_method = 9 valeur historique
                    id_payment_method: 9,
                    id_payment_mode: paymentMode.id,
                    // TODO utiliser la valeur du panier, en dur pour le test
                    attach_to_cart: attach_to_cart,
                    id_store: id_store,
                    cbBrand: selectedBrand.get('brand'),
                    storepermently: storepermently
                };
            ApiRequest('ToolsPaymentMethod',requestParams,{method: 'getCbEncrypt'})
                .done(function (data) {
                    details$El.html(data.iframe);
                })
                .fail(function(){
                    app.blockError(details$El);
                    app.error('ToolsPaymentModeError',requestParams);
                });
        },
        onIframeSuccess:function(data){
            // TODO
            var view = this,
                paymentMode = view.paymentMode,
                storing = data.storing === '1';
            var cardOptions = _.pick(data,['id_card','brand','cardNum','expiryDate']),
                success = data.status === 'success',
                alertType = success ? 'success':'danger';
            if(success){
                cardOptions.used = false;
                cardOptions.temporary = !storing;
                app.getCustomer().addPaymentCard(cardOptions);
                paymentMode.setOption('id_card',data.id_card,true);
                view.close();
            }else{
                var message = data.message || 'Oups…';
                view.$('.ogone__iframe-wrapper').html('<div class="alert alert-'+alertType+'">'+message+'</div>');
            }
        },
        submitForm:function(e){
            var view = this,
                cvc = ''+view.$('[name=cvc]').val(),
                paymentMode = view.paymentMode;
            if(selectedBrand.isDirectLink()){
                cvc = parseFloat(cvc.replace(',','.'));
                if(_.isNaN(cvc) || cvc<=0) cvc = 0;
                paymentMode.setOption('cvc',cvc,true);
            }else{
                paymentMode.setOptions({
                   directlink:0,
                   cbBrand:selectedBrand.get('brand')
                },true);
            }
            view.close();
            return false;
        }
    });
});
